﻿window.cObjetDocCptLigneMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () {
        if (typeof objet.data == 'undefined') {
            return "Document comptable";
        } else {
            return this.mGetNomDocument()
        }
    }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau document comptable"; }
    this.mGetLib1 = function (option) {
        return ""
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null
        $Icone = $("<i class='fas fa-wallet'></i>");
        return $Icone
    }

}